/* 登录状态 */
export const IS_LOGGING_IN = "isLoggingIn";
/* 缺省安全校验方式 */
export const DEFAULT_SAFETY_CHECK_MODE = "defaultSafetyCheckMode";
/* 最近搜索词 */
export const SEARCH_WORD_ARRAY = "";